import Cookies from 'js-cookie';
 
class CookieService {
  public static GetCookie = (key: string) => {
    return Cookies.get(key);
  };
 
  public static SaveCookie = (key: string, value: string | object, options?: any) => {
    if (!options)
      return Cookies.set(key, value);
    else
      return Cookies.set(key, value, options);
  };
 
  public static DeleteCookie = (key: string) => {
    return Cookies.remove(key);
  };
}
 
export { CookieService };
 